import { render, staticRenderFns } from "./ManualTransfers.vue?vue&type=template&id=dba2355c&scoped=true&"
import script from "./ManualTransfers.vue?vue&type=script&lang=js&"
export * from "./ManualTransfers.vue?vue&type=script&lang=js&"
import style0 from "./ManualTransfers.vue?vue&type=style&index=0&id=dba2355c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dba2355c",
  null
  
)

export default component.exports